

export const SET_ACCESSORIAL_RATE_UI = "SET_ACCESSORIAL_RATE_UI";
export function setAccessorialRateUi(state) {
  return {
    type: SET_ACCESSORIAL_RATE_UI,
    ...state
  };
}


export const SET_TERMINAL = 'SET_TERMINAL';
export function setTerminal(terminalId) {
  return {
    type: SET_TERMINAL,
    terminalId
  };
}



// WEBPACK FOOTER //
// ./src/containers/AccessorialsAndFees/AccessorialsAndFeesUiActions.js